import { Routes } from '@angular/router';

export const supportRoutes: Routes = [
  {
    path: 'clear',
    loadComponent: () => import('./support/support.component').then(m => m.SupportComponent),
    data: { action: 'clearStorage' },
  },
];
